import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import SpeedMeter from 'src/Home/SpeedMeter'
import AdditionalDetail from 'src/Home/AdditionalDetail'
import { ReactComponent as InfoIcon } from 'images/info_icon.svg'
import CardInfo from 'src/Component/CardInfo'
import { Body1 } from 'src/Styles/text-styles'
import { theme } from 'src/Styles/theme'
import { Route } from 'src/Common/Route'
import { useSpeedTestEngine } from 'src/lib/ookla_speed_test'
import useMediaQuery from 'src/Utils/useMediaQuery'
import { RouteComponentProps } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { analytics } from 'src/Analytics'
import { SpeedTestQuestionsTappedEvent } from 'src/Analytics/SpeedTestEvents'
import useAppStack from 'src/App/useAppStack'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  flex: 1;
  padding-bottom: 40px;
`

const InnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
  margin: 32px;

  @media (min-width: 1024px) {
    flex-wrap: nowrap;
    margin-left: 160px;
    margin-right: 160px;
    & > * {
      flex: 1;
      margin: 16px;
    }
  }
`

const InnerColumnContainer = styled.div<{ visibility: boolean }>`
  display: ${({ visibility }) => (visibility ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  align-self: flex-start;

  @media (min-width: 1024px) {
    flex-wrap: nowrap;
    margin-left: 16px;
    margin-right: 16px;
    & > * {
      flex: 1;
    }
  }
`

const InnerColumnContainerAdditionalDetails = styled.div<{
  visibility: boolean
}>`
  display: ${({ visibility }) => (visibility ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  align-self: flex-start;
  max-width: 30%;
  @media (min-width: 1024px) {
    flex-wrap: nowrap;
    margin-left: 16px;
    margin-right: 16px;
    & > * {
      flex: 1;
    }
  }
`

const CellularNetowrkNote = styled(Body1)`
  @media (max-width: 768px) {
    display: inherit;
    font-size: 12px;
    margin-left: 8dp;
    margin-right: 8dp;
    color: ${theme.colors.lightTextColor};
    text-align: center;
  }

  @media (min-width: 768px) {
    display: none;
    margin-left: 8dp;
    margin-right: 8dp;
  }
`
//This code should be removed once transaltions started
//Now keeping this for translation reference

const cellularNetworkText = localize('LABEL')(
  'Turn off Wi-Fi network to test mobile network'
)
const speedCheckQuestionTitle = localize('TITLE')('Speed check questions?')
const speedCheckQuestionDescription = localize('LABEL')(
  'Learn about speed check and understanding the results'
)

interface Props {
  props: RouteComponentProps
}
export default ({ props }: Props) => {
  const {
    testState,
    startTest,
    latency,
    download,
    upload,
    progress,
    searchServer,
    sortedServer,
    clientIP,
    guid,
    isOptimalLocationLoaded,
  } = useSpeedTestEngine()

  const [serverLocation, setServerLocation] = useState<string>()
  const history = useHistory()

  const { push } = useAppStack()

  useEffect(() => {
    if (sortedServer) {
      setServerLocation(`${sortedServer?.name} ${sortedServer?.country}`)
      const state: any = props.location.state
      const restartSpeedCheck: boolean = state?.restart
      console.log(`Home Log: ${JSON.stringify(state)}`)
      if (restartSpeedCheck !== undefined) {
        startTest()
      }
    }
  }, [sortedServer])

  useEffect(() => {
    if (!sortedServer) {
      searchServer()
    }
  }, [])

  const isMobileView = useMediaQuery(['(max-width: 768px)'], [true], false)

  const onNavigate = () => {
    history.push(Route.SPEED_TEST_DETAIL)
    push()
    analytics.trackEvent(SpeedTestQuestionsTappedEvent())
  }

  return (
    <Container>
      <SpeedMeter
        testState={testState}
        startTest={startTest}
        latency={latency}
        download={download}
        upload={upload}
        progress={progress}
        sortedServer={sortedServer}
        clientIP={clientIP}
        guid={guid}
        isOptimalLocationLoaded={isOptimalLocationLoaded}
      />
      <CellularNetowrkNote>{cellularNetworkText}</CellularNetowrkNote>
      <InnerContainer>
        <InnerColumnContainerAdditionalDetails visibility={!isMobileView}>
          <AdditionalDetail
            serverLocation={serverLocation!}
            serverHost={sortedServer?.sponsor!}
          />
        </InnerColumnContainerAdditionalDetails>

        <InnerColumnContainer visibility={true}>
          <CardInfo
            title={speedCheckQuestionTitle}
            description={speedCheckQuestionDescription}
            InfoIcon={InfoIcon}
            onPress={onNavigate}
          />
        </InnerColumnContainer>
      </InnerContainer>
    </Container>
  )
}
